import { Stack, styled, Typography } from '@mui/material'

function PageHeader({ title, description }: { title: string; description: string; }) {
    return (
        <Stack gap={{md:3, xs:2}} mt={{xs:3, md:0}}>
            <Typography variant='h5' fontWeight={600}>{title}</Typography>
            <Typography variant='body2' color='text.secondary' sx={{ fontWeight: 400 }}  >{description}</Typography>
        </Stack>
    )
}

export default PageHeader